<template>
    <b-row class="p-0 p-0">
    
       
        
        <!-- begining of the question answer -->
        <b-col lg="12" class="p-0 m-0 ">
            <b-row class="p-0 m-0 ">
               
                <b-col lg="12" class="m-0 p-0 text-center">
                  
                   <div class="mx-auto my-5 p-4 p-md-5 rounded-4 text-white shadow-lg"
     style="background: rgba(0,0,0,0.86); max-width: 980px; text-align: justify; line-height: 1.55;">

  <!-- Header -->
  <div class="d-flex align-items-center mb-4" style="gap: 1.2rem;">
    <div class="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
         style="width:68px;height:68px;background:linear-gradient(135deg,#0d6efd,#6f42c1);
                box-shadow:0 8px 24px rgba(0,0,0,.35), inset 0 0 0 2px rgba(255,255,255,.15);">
      <!-- info-circle icon -->
      <svg width="38" height="38" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
        <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM7 7.5h2V12H7V7.5z"/>
      </svg>
    </div>
    <div class="flex-grow-1">
      <h2 class="fw-bold mb-1" style="letter-spacing:.3px; font-size:clamp(1.9rem,2.2vw+1rem,2.6rem); line-height:1.15;">
        О компании
      </h2>
      <div class="text-white-50" style="font-size:.95rem;">Payton.kz / Digital Galaxy Ltd. · AIFC / AFSA</div>
    </div>
  </div>

  <!-- About -->
  <p><strong>Payton.kz</strong> – это лицензированный провайдер услуг, зарегистрированный в Международном финансовом центре «Астана» (AIFC)
    и регулируемый <strong>Astana Financial Services Authority (AFSA)</strong>, юридическое наименование – Частная компания <strong>Digital Galaxy Ltd.</strong>
    Подробная информация о регулируемых видах деятельности компании представлена в разделе «Лицензии и регулирование».
  </p>

  <p>Наша компания предоставляет современную и безопасную инфраструктуру для покупки, продажи и обмена цифровых активов — как для физических, так и для юридических лиц.</p>

  <!-- Mission -->
  <div class="mt-4">
    <div class="d-flex align-items-center mb-2" style="gap:.6rem; line-height:1.1;">
      <!-- target/mission icon -->
      <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
        <path d="M8 3a5 5 0 1 1-4.546 2.916l.914.405A4 4 0 1 0 8 4V3z"/>
        <path d="M7.5 8V4h1v4h-1zm0 1.5h1V10h-1V9.5z"/>
      </svg>
      <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">Наша миссия</h5>
    </div>
    <p>Мы стремимся сделать рынок цифровых активов прозрачным, надёжным и доступным каждому пользователю.</p>
    <p><strong>Digital Galaxy Ltd.</strong> создаёт экосистему, где технологии и регулирование работают в интересах клиента, обеспечивая максимальный уровень безопасности и доверия при совершении операций с криптоактивами.</p>
  </div>

  <!-- Services -->
  <div class="mt-4">
    <div class="d-flex align-items-center mb-2" style="gap:.6rem; line-height:1.1;">
      <!-- services/briefcase icon -->
      <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
        <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H3a2 2 0 0 0-2 2v2h14V5a2 2 0 0 0-2-2h-2v-.5A1.5 1.5 0 0 0 9.5 1h-3zM9 3H7V2.5a.5.5 0 0 1 .5-.5h1A.5.5 0 0 1 9 2.5V3z"/>
        <path d="M15 8H1v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/>
      </svg>
      <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">Наши услуги</h5>
    </div>
    <p class="mb-2">Мы предоставляем клиентам:</p>
    <ul class="mb-0 ps-3" style="line-height:1.55;">
      <li>Быструю покупку и продажу криптовалют за тенге и другие фиатные валюты;</li>
      <li>Конвертацию между различными цифровыми активами;</li>
      <li>Корпоративные решения для компаний, работающих с криптоактивами;</li>
      <li>Индивидуальные условия обслуживания для крупных клиентов.</li>
    </ul>
    <p class="mt-3 mb-0">Digital Galaxy выступает в качестве надёжного посредника между клиентом и ведущими мировыми криптобиржами, обеспечивая лучшие рыночные курсы и мгновенное исполнение ордеров.</p>
  </div>

  <!-- Principles -->
  <div class="mt-4">
    <div class="d-flex align-items-center mb-2" style="gap:.6rem; line-height:1.1;">
      <!-- shield/principles icon -->
      <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
        <path d="M5.338 1.59a61 61 0 0 0-2.837.856A1 1 0 0 0 1 3.39V6c0 5.255 3.522 7.507 6.364 8.651a1 1 0 0 0 .272.06 1 1 0 0 0 .272-.06C10.75 13.507 14 11.255 14 6V3.39a1 1 0 0 0-.5-.864 61 61 0 0 0-2.838-.856c-.39-.12-.778-.24-1.158-.368a4 4 0 0 0-2.008 0c-.38.128-.768.248-1.158.368"/>
        <path d="M10.97 5.97a.75.75 0 0 1 0 1.06L7.477 10.52a.75.75 0 0 1-1.06 0L5.03 9.13a.75.75 0 1 1 1.06-1.06l.887.886 3-3a.75.75 0 0 1 1.06 0"/>
      </svg>
      <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">Наши принципы</h5>
    </div>
    <ul class="mb-0 ps-3" style="line-height:1.55;">
      <li><strong>Прозрачность:</strong> все операции осуществляются в рамках лицензии AFSA;</li>
      <li><strong>Безопасность:</strong> защита данных и средств клиентов – наш приоритет;</li>
      <li><strong>Ответственность:</strong> соблюдаем требования международных стандартов и регуляторов;</li>
      <li><strong>Инновации:</strong> внедряем современные технологические решения для удобства и скорости работы с цифровыми активами.</li>
    </ul>
  </div>

  <!-- Regulation & Security -->
  <div class="mt-4">
    <div class="d-flex align-items-center mb-2" style="gap:.6rem; line-height:1.1;">
      <!-- lock/regulation icon -->
      <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
        <path d="M8 1a3 3 0 0 0-3 3v2H4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-1V4a3 3 0 0 0-3-3zM6 6V4a2 2 0 1 1 4 0v2H6z"/>
      </svg>
      <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">Регулирование и безопасность</h5>
    </div>
    <p>Digital Galaxy Ltd. действует в соответствии с законодательством AIFC и всеми требованиями AFSA в области:</p>
    <ul class="mb-3 ps-3" style="line-height:1.55;">
      <li><strong>AML/CFT</strong> (противодействие отмыванию денег и финансированию терроризма);</li>
      <li><strong>KYC</strong> (идентификация клиентов) и <strong>KYT</strong> (мониторинг транзакций);</li>
      <li>соблюдения международного стандарта <strong>Travel Rule</strong> для безопасных межбиржевых переводов.</li>
    </ul>
    <p class="mb-0">Безопасность наших клиентов обеспечивается партнёрством с проверенными и лицензированными <strong>Digital Wallet Service Providers</strong>, использующими технологии холодного хранения, многоуровневую аутентификацию и постоянный мониторинг операций.</p>
  </div>
</div>


                </b-col>
               
            </b-row>
        </b-col>

    </b-row>
</template>

<script>
    
    import axios from 'axios';
    import {mapActions,mapState} from 'vuex';
    export default {
        name: "About",
        data(){
            return {
                svgWidth: 150,
                svgHeight: 30,
                coinData: [],
                items: [
                    { title: "Как это работает?", content: "Здесь будет текстовое описание", active: false },
                    { title: "Как я могу торговать криптовалютой?", content: "Здесь будет текстовое описание", active: false },
                ]
            }
        },
        methods:{
            changeRoute(routeName){
                this.$router.push('/'+routeName)
            },
            async fetchBitcoinPriceData(ids) {
                const endpoint = 'https://api.coingecko.com/api/v3/coins/markets?x_cg_demo_api_key=CG-UhwnpGqWNHeMipRrQ8Wr5Yxr';
                const params = {
                    vs_currency: 'usd',
                    days: 0, // Fetch 7 days of data
                    interval: 'daily',
                    ids:ids,
                    order: 'market_cap_desc', // Order by market capitalization
                    per_page: 2, // Number of coins per page
                    page: 1, // Page number
                    sparkline: true // Disable sparkline
                };

                try {
                    const response = await axios.get(endpoint, {
                        params: params,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CoinGecko-Api-Key': 'CG-UhwnpGqWNHeMipRrQ8Wr5Yxr'
                        }
                    });
                    
                    console.log('Bitcoin price data:', response.data);
                    
                
                    // Truncate sparkline_in_7d to include only the last 7 days
                    const coinData = response.data.map(coin => {
                        const sparklineData = coin.sparkline_in_7d.price.slice(-7); // Get the last 7 days
                        return { ...coin, sparkline_in_7d: sparklineData };
                    });

                    
                    this.coinData = this.coinData.concat(coinData);
                    
                } catch (error) {
                    console.error('Error fetching Bitcoin price data:', error);
                }
            },
            generatePath(priceData, index) {
                const dataLength = priceData.length;
                const priceMax = Math.max(...priceData);
                const priceMin = Math.min(...priceData);
                const priceRange = priceMax - priceMin;
                const xStep = this.svgWidth / (dataLength - 1);

                let path = `M0 ${this.svgHeight - ((priceData[0] - priceMin) / priceRange) * this.svgHeight}`;
                for (let i = 1; i < dataLength; i++) {
                    const x = i * xStep;
                    const y = this.svgHeight - ((priceData[i] - priceMin) / priceRange) * this.svgHeight;
                    path += ` L${x} ${y}`;
                }

                return path;
            },
            toggleAccordion(index) {
                this.items[index].active = !this.items[index].active;
            },
            hasRole(roleName){
                if(this.loginedUser && this.loginedUser.userRoles){
                    let roleNames = this.loginedUser.userRoles;
                    if(roleNames.length>0){
                    //alert(JSON.stringify(roleNames));
                    for(let r=0;r<roleNames.length;r++){
                        
                        if(roleNames[r].name===roleName){
                        return true;
                        }
                    }
                    }
                    else{
                    return false;
                    }
                }
                return false;
                
                
            }
        },
        mounted(){
            this.fetchBitcoinPriceData( 'bitcoin,ethereum');
      
            this.fetchBitcoinPriceData( 'tether,binancecoin');
        },
        computed:{
            ...mapState([
                'loginedUser'
            ]),
        }
        
    }   
</script>
<style>
    .copyright{        
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .main-bottom-top{
        height: 1px;
        background: var(--Neutrals-2, #23262F);
    }
    .no-style-input{
        appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        font-family: inherit;
        font-size: inherit;
        color: inherit;
        line-height: inherit;
        padding: 0;
        margin: 0;
    }
    .sub-container{
        border-radius: 16px;
        border: 2px solid var(--Neutrals-6, #E6E8EC);
    }
    .footer-addr{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .footer-link{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .accordion-item{
        cursor: pointer;
    }
    .accordion-item-answer{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .accordion-item-question{
        cursor: pointer;
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .accordion-item {
        width: 100%;
        max-width: 546px;
        margin: 0 auto;
        border-bottom:1px solid var(--Neutrals-3, #353945);
        
    }
    .service-btn-container{
        cursor: pointer;
        border-radius: 12px;
        background: var(--Primary-1, #EFB914);
    }
    .service-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .service-item-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .service-item-name{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .service-item{
        border-radius: 20px;
        background: var(--Neutrals-1, #141416);
    }
    .service-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .no-style {
        color: inherit; /* Inherit color from parent */
        text-decoration: none; /* Remove underline */
    }
    .news-item-desc{
        
        color: var(--Neutrals-4, #777E90);
        overflow: visible; 
        white-space: normal; 
        text-overflow: clip;
        /* Caption */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
    }
    .news-item-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .main-news-desc{
        overflow: hidden;
        color: var(--Neutrals-4, #777E90);
        text-overflow: ellipsis;
        white-space: pre-wrap;
        height: auto;
        /* Body 2 */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }
    .main-news-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px; /* 125% */
        letter-spacing: -0.96px;
    }
    .trade-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .trade-btn{
        cursor: pointer;
        border-radius: 8px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .list-text-percentage{
        color: var(--Primary-4, #58BD7D);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-price{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; 
    }
    .list-sep{
        height: 1px;
        border-radius: 2px;
        background: var(--Neutrals-3, #353945);
    }
    .list-text-code{
        color: var(--Neutrals-5, #B1B5C3);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-crypto{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-number{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-header-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .tab-btn:hover{
        cursor: pointer;
        border-radius: 8px;
        background: var(--Neutrals-3, #353945);
    }
    .tab-btn:hover .tab-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
    }
    .tab-btn-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-container{
        cursor: pointer;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .clist-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px;
        letter-spacing: -0.96px;
    }
    .main-sep{
        height: 1px;
        background: #B1B5C3;
    }
    .crypto-cost-current{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
    }
    .crypto-cost-prev{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .crypto-percentage{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        border-radius: 24px;
        background: var(--Primary-3, #FF6838);
    }
    .crypto-name{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
    .crypto-item:hover{
        cursor: pointer;
        border-radius: 16px;
        background: var(--Neutrals-3, #353945);
        box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.10);
    }
    .banner-crypto-container{
        border-radius: 24px;
        background: var(--Neutrals-2, #23262F);
    }
    .banner-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 64px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        letter-spacing: -1.28px;
    }
    .banner-desc{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .crypto-btn{
        border-radius: 12px;
        border: 2px solid var(--Neutrals-4, #777E90);
    }
    .crypto-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: right;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
</style>

